module.exports = __webpack_public_path__ + "img/background1.ddc1118e.png";